import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

export const useSelectedDate = () => {
  const { date: dateParam } = useParams<'date'>();

  if (!dateParam) {
    throw Error('Date must be provided.');
  }

  return useMemo(() => new Date(dateParam), [dateParam]);
};
